import PropTypes from 'prop-types';

import TopBar from 'layouts/Common/TopBar';

import useStyles from './styles';

function RequestLayout({ children }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <TopBar
        isMenuCollapsible={false}
      />

      <div className={classes.wrapperCollapsed}>
        <div className={classes.contentContainer}>
          <div
            children={children}
            className={classes.content}
          />
        </div>
      </div>
    </div>
  );
}

RequestLayout.propTypes = {
  children: PropTypes.any,
};

export default RequestLayout;
